import { render, staticRenderFns } from "./WordSeparatorPage.vue?vue&type=template&id=27113cc8&"
import script from "./WordSeparatorPage.vue?vue&type=script&lang=js&"
export * from "./WordSeparatorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports